import React from "react"
import { RenderElementProps } from "slate-react"

const CopytextTeaser = ({ children, attributes }: RenderElementProps) => {
    return (
        <p {...attributes} className="mb-4 text-sm last:mb-0 sm:mb-5 sm:text-base md:text-md">
            {children}
        </p>
    )
}

export default CopytextTeaser
